import { render, staticRenderFns } from "./AllFilesUpload.vue?vue&type=template&id=fafde30e"
import script from "./AllFilesUpload.vue?vue&type=script&lang=js"
export * from "./AllFilesUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports